<template>
  <ResetPassword />
</template>

<script>
import ResetPassword from "@/components/Auth/ResetPassword/Reset.vue";

export default {
  name: "PasswordResetView",
  components: {
    ResetPassword,
  },
};
</script>
